import { useQuery } from '@tanstack/react-query'

import { encodeQueryString } from '../../../../app/queryString'
import { apiRequest } from '../../../services/api'
import { DEFAULT_QUERY_CACHE_TIME_IN_MS, ManagerData } from '../constants'

interface Props {
  id: number | string
  reportEndDate?: string
  initialData?: ManagerData | null
}

export function useManagerDetailsData({ id, reportEndDate, initialData }: Props) {
  const managerDetailsQuery = useQuery({
    queryKey: ['managerDetails', id, reportEndDate],
    queryFn: async () => apiRequest<ManagerData>(`/api/managers/${id}?${encodeQueryString({ reportEndDate })}`),
    initialData: initialData ?? undefined,
    keepPreviousData: true,
    staleTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
    cacheTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
  })

  return managerDetailsQuery
}
